import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  CircularProgress,
  Backdrop,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  List
} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { SettingRowText } from './setting-row-text';
import { enableOtpNotifications, disableOtpNotifications } from '../redux/actions/client-actions';
import { SnackbarComponent } from '../../../../core/utils/components/snackbar-component';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  root: {
    marginTop: theme.spacing(2),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  granted: {
    color: '#4caf50'
  }
}));

export function DriverOtpNotificationsComponent({ client }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [backdrop, setBackdrop] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState({ status: 'success', description: 'Permission updated' });

  const closeSnackbar = () => setSnackbar(false);
  const startLoader = () => setBackdrop(true);
  const closeLoader = () => setBackdrop(false);

  const showSnackbar = (status = 'success', description = 'Permission updated') => {
    setSnackbar(true);
    setMessage({ status, description });
    closeLoader();
  };

  const enableOtp = () => {
    startLoader();
    const props = { closeLoader, showSnackbar };
    dispatch(enableOtpNotifications(client.id, props));
  };

  const disableOtp = () => {
    startLoader();
    const props = { closeLoader, showSnackbar };
    dispatch(disableOtpNotifications(client.id, props));
  };

  // settings.driver.password_reset is the flag the driver OTP flow actually gates on. The old
  // settings.notifications.otp.enabled is read by nothing outside this screen, so the dot used to
  // report a status that had no bearing on whether drivers could request a reset code.
  const otpEnabled = client.settings?.driver?.password_reset || false;

  return (
    <>
      <List className={classes.root}>
        <ListItem>
          <ListItemIcon>
            {otpEnabled ? (
              <FiberManualRecordIcon className={classes.granted} />
            ) : (
              <FiberManualRecordIcon color="error" />
            )}
          </ListItemIcon>
          <SettingRowText
            title="Driver App Password Reset"
            hint="Lets this client’s drivers reset their own password with an SMS code. Every code sends on Loop’s own cm.com account, so there is no per-client token to set — this is on or off."
          />
          <ListItemSecondaryAction>
            {otpEnabled ? (
              <Button
                type="button"
                variant="outlined"
                size="small"
                color="secondary"
                onClick={disableOtp}
              >
                Disable
              </Button>
            ) : (
              <Button
                type="button"
                variant="contained"
                size="small"
                color="secondary"
                onClick={enableOtp}
              >
                Enable
              </Button>
            )}
          </ListItemSecondaryAction>
        </ListItem>
      </List>

      <Backdrop className={classes.backdrop} open={backdrop} onClick={closeLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <SnackbarComponent
        open={snackbar}
        onClose={closeSnackbar}
        severity={message.status}
        message={message.description}
      />
    </>
  );
}
